import http from "@/services/http";
import { ControlHandle, IControlStartedBoardReq, IControlUnStartBoardReq, IHotWordsRes, ISaveSpeechDraftReq } from "@/types/simulInter";
import { AxiosRequestConfig } from "axios";

// 提炼热词
export function generateHotWords(params: { streamName: string, url: string }, config?: AxiosRequestConfig<unknown>) {
  return http.post<string[]>("/api/auth/temporary/hotword/extract", params, { ...config });
}

// 查询临时热词
export function getHotWords(streamName: string, config?: AxiosRequestConfig<unknown>) {
  return http.get<IHotWordsRes>(`/api/auth/temporary/hotword?streamName=${streamName}`, { ...config });
}

// 修改临时热词（enhanceEnable 可选，用于同时控制热词增强开关）
export function updateHotWords(params: { streamName: string, words: string[], enhanceEnable?: boolean }) {
  return http.post<boolean>("/api/auth/temporary/hotword/edit", params);
}

// 删除临时热词
export async function deleteHotWords(streamName: string) {
  return http.delete<boolean>(
    `api/auth/temporary/hotword?streamName=${streamName}`
  );
}

// 查询发言稿,获取文件预览地址
export function getSpeechDraft(streamName: string, fileName: string) {
  return http.get<string>(`/api/open/file-upload/download-preview-url?streamName=${streamName}&fileName=${fileName}`);
}

// 发言稿上传-处理
export function saveSpeechDraft(params: ISaveSpeechDraftReq, config?: AxiosRequestConfig<unknown>) {
  return http.post<boolean>("/api/auth/record-server/controller/upload/handle", params, { ...config });
}

// 删除发言稿
export async function deleteSpeechDraft(streamName: string) {
  return http.delete<boolean>(
    `/api/auth/record-server/controller/report?streamName=${streamName}`
  );
}

// 下载发言稿
export function getSpeechDraftDownloadUrl(params: { streamName: string; }) {
  const { streamName } = params;
  return http.get(`/api/auth/record-server/meeting/download-report?streamName=${streamName}`);
}

// 设备控制操作（大板启动）
export function controlStartedBoard(params: IControlStartedBoardReq) {
  return http.post<{ streamName: string; controlHandle: ControlHandle }>("/api/auth/record-server/controller/operation", params);
}

// 设备控制操作（大板未启动）
export function controlUnStartedBoard(params: IControlUnStartBoardReq) {
  return http.post<{ streamName: string; }>("/api/auth/record-server/controller/recordHandle", params);
}

// 清屏指令
export function clearSubtitle(streamName: string) {
  return http.post("/api/auth/record-server/sync/operateOrder", { streamName, 'operate': 'ON_CLEAR_SCREEN' });
}